import { render, staticRenderFns } from "./MSV.vue?vue&type=template&id=6492ed4a&scoped=true"
import script from "./MSV.vue?vue&type=script&lang=js"
export * from "./MSV.vue?vue&type=script&lang=js"
import style0 from "./MSV.vue?vue&type=style&index=0&id=6492ed4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6492ed4a",
  null
  
)

export default component.exports